<template>

  <div class='chart-wrapper solarchart'>
    <h2 class="chart-header">Monday</h2>
    <div class="chart">
    </div>
  </div>

</template>

<script>

  import * as d3 from 'd3';
  import solarChart from '@/charts/solarSystemChart'

  const fakedata = [
  {
    "time_period": "2019-01-30T00:00:00Z",
    "ata_minus_pta": -44.9,
    "volume": 3
  },
  {
    "time_period": "2019-01-30T01:00:00Z",
    "ata_minus_pta": -2.9,
    "volume": 2
  },
  {
    "time_period": "2019-01-30T02:00:00Z",
    "ata_minus_pta": -3.9,
    "volume": 2
  },
  {
    "time_period": "2019-01-30T03:00:00Z",
    "ata_minus_pta": 36.0,
    "volume": 2
  },
  {
    "time_period": "2019-01-30T04:00:00Z",
    "ata_minus_pta": -18.8,
    "volume": 1
  },
  {
    "time_period": "2019-01-30T05:00:00Z",
    "ata_minus_pta": 5.7,
    "volume": 1
  },
  {
    "time_period": "2019-01-30T06:00:00Z",
    "ata_minus_pta": -15.2,
    "volume": 11
  },
  {
    "time_period": "2019-01-30T07:00:00Z",
    "ata_minus_pta": -25.6,
    "volume": 27
  },
  {
    "time_period": "2019-01-30T08:00:00Z",
    "ata_minus_pta": -39.9,
    "volume": 47
  },
  {
    "time_period": "2019-01-30T09:00:00Z",
    "ata_minus_pta": -32.7,
    "volume": 50
  },
  {
    "time_period": "2019-01-30T10:00:00Z",
    "ata_minus_pta": -33.9,
    "volume": 39
  },
  {
    "time_period": "2019-01-30T11:00:00Z",
    "ata_minus_pta": -42.9,
    "volume": 56
  },
  {
    "time_period": "2019-01-30T12:00:00Z",
    "ata_minus_pta": -38.1,
    "volume": 49
  },
  {
    "time_period": "2019-01-30T13:00:00Z",
    "ata_minus_pta": -38.0,
    "volume": 45
  },
  {
    "time_period": "2019-01-30T14:00:00Z",
    "ata_minus_pta": -40.9,
    "volume": 49
  },
  {
    "time_period": "2019-01-30T15:00:00Z",
    "ata_minus_pta": -34.6,
    "volume": 57
  },
  {
    "time_period": "2019-01-30T16:00:00Z",
    "ata_minus_pta": -36.6,
    "volume": 39
  },
  {
    "time_period": "2019-01-30T17:00:00Z",
    "ata_minus_pta": -38.2,
    "volume": 53
  },
  {
    "time_period": "2019-01-30T18:00:00Z",
    "ata_minus_pta": -52.3,
    "volume": 26
  },
  {
    "time_period": "2019-01-30T19:00:00Z",
    "ata_minus_pta": -40.5,
    "volume": 20
  },
  {
    "time_period": "2019-01-30T20:00:00Z",
    "ata_minus_pta": -34.9,
    "volume": 18
  },
  {
    "time_period": "2019-01-30T21:00:00Z",
    "ata_minus_pta": -38.1,
    "volume": 4
  }
]

	export default {
		name: "SolarChart",
    data: function() {
			return {
				fakedata,
      }
    },
    mounted() {
      d3.select(this.$el).select('.chart')
        .datum(this.fakedata) // bind data to the div
        .call(solarChart().timeScale('hourly'));
    }
	}
</script>

<style lang="less">

    @import "../../assets/less/palette.less";

  .solarchart {
    width: 80vw;
    max-width: 500px;
    margin: auto;

    .chart-header {
      margin-bottom: -1em;

    }

    g.axis {
      line, path {
        stroke: @primary-3;
      }

      text {
        fill: @primary-4
      }
    }

  }

</style>
